export const QualificationIssuer = {
  KUTSEKODA: 1,
  IFFENT: 2
}